import React, { Fragment, memo, useEffect, useState } from 'react';
import { Route, RouteProps, useHistory } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import Header from 'src/routes/Layout/Header';
import { Content } from './styles';
import { Container } from 'src/routes/Layout/Page/styles';
import enRoles from 'src/models/enums/enRoles';
import PermissionHide from './Hide';

interface IProps extends RouteProps {
  roles?: enRoles | enRoles[];
  children?: JSX.Element;
}

const PermissionRoute = memo<IProps>((props) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const { roles } = props;
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      const _roles = Array.isArray(props.roles) ? props.roles : (props.roles ? [props.roles] : []);
      setIsAuthenticated(Boolean(_roles.length))
    }
    else {
      history.push('/login');
    }
  }, [history, user, props.roles]);

  return isAuthenticated ? (
    <Fragment>
      <PermissionHide roles={roles}>{<Route {...props} />}</PermissionHide>

      <PermissionHide inverse roles={roles}>
        <Container>
          <Header />
          <Content>Não autorizado.</Content>
        </Container>
      </PermissionHide>
    </Fragment>
  ) : null;
})

export default PermissionRoute;

